import { asManagerId } from '@ludus/core'
import type { ManagerSchedule } from '../types.ts'
import { addDays, startOfISOWeek, toISODate } from '../utils/weekRange.ts'

/**
 * Generates mock schedules with exceptions positioned within the ISO week of
 * `reference` so the demo always has visible exceptions when first opened.
 *
 * MVP: managers are tied to mockManagers in `apps/console/src/shared/mocks/managers.ts`
 * by id. When the real Managers feature ships, replace this and `useScheduleSource`
 * with API-backed sources.
 */
export function buildMockSchedules(reference: Date): ManagerSchedule[] {
  const monday = startOfISOWeek(reference)
  const friday = toISODate(addDays(monday, 4))
  const tuesday = toISODate(addDays(monday, 1))
  const wednesday = toISODate(addDays(monday, 2))
  const saturday = toISODate(addDays(monday, 5))

  const m = (h: number) => h * 60

  return [
    {
      managerId: asManagerId('mock-mgr-anna'),
      weeklyTemplate: [
        { weekday: 1, windows: [{ startMinute: m(9), endMinute: m(17) }] },
        { weekday: 2, windows: [{ startMinute: m(9), endMinute: m(17) }] },
        { weekday: 3, windows: [{ startMinute: m(9), endMinute: m(17) }] },
        { weekday: 4, windows: [{ startMinute: m(9), endMinute: m(17) }] },
        { weekday: 5, windows: [{ startMinute: m(9), endMinute: m(17) }] },
      ],
      exceptions: [
        {
          managerId: asManagerId('mock-mgr-anna'),
          date: friday,
          windows: [
            { startMinute: m(9), endMinute: m(17) },
            { startMinute: m(18), endMinute: m(21) },
          ],
        },
      ],
    },
    {
      managerId: asManagerId('mock-mgr-bohdan'),
      weeklyTemplate: [
        {
          weekday: 1,
          windows: [
            { startMinute: m(8), endMinute: m(12) },
            { startMinute: m(14), endMinute: m(18) },
          ],
        },
        {
          weekday: 2,
          windows: [
            { startMinute: m(8), endMinute: m(12) },
            { startMinute: m(14), endMinute: m(18) },
          ],
        },
        {
          weekday: 3,
          windows: [
            { startMinute: m(8), endMinute: m(12) },
            { startMinute: m(14), endMinute: m(18) },
          ],
        },
        { weekday: 4, windows: [{ startMinute: m(10), endMinute: m(15) }] },
        { weekday: 5, windows: [{ startMinute: m(10), endMinute: m(15) }] },
      ],
      exceptions: [
        {
          managerId: asManagerId('mock-mgr-bohdan'),
          date: tuesday,
          windows: null,
        },
      ],
    },
    {
      managerId: asManagerId('mock-mgr-clara'),
      weeklyTemplate: [
        { weekday: 2, windows: [{ startMinute: m(11), endMinute: m(19) }] },
        { weekday: 3, windows: [{ startMinute: m(11), endMinute: m(19) }] },
        { weekday: 4, windows: [{ startMinute: m(11), endMinute: m(19) }] },
        { weekday: 5, windows: [{ startMinute: m(11), endMinute: m(19) }] },
        { weekday: 6, windows: [{ startMinute: m(11), endMinute: m(19) }] },
      ],
      exceptions: [
        {
          managerId: asManagerId('mock-mgr-clara'),
          date: wednesday,
          windows: [{ startMinute: m(9), endMinute: m(13) }],
        },
      ],
    },
    {
      managerId: asManagerId('mock-mgr-dmytro'),
      weeklyTemplate: [
        { weekday: 6, windows: [{ startMinute: m(12), endMinute: m(20) }] },
        { weekday: 0, windows: [{ startMinute: m(12), endMinute: m(20) }] },
      ],
      exceptions: [],
    },
    {
      managerId: asManagerId('mock-mgr-elena'),
      weeklyTemplate: [
        { weekday: 1, windows: [{ startMinute: m(7), endMinute: m(15) }] },
        { weekday: 2, windows: [{ startMinute: m(7), endMinute: m(15) }] },
        { weekday: 3, windows: [{ startMinute: m(7), endMinute: m(15) }] },
        { weekday: 4, windows: [{ startMinute: m(7), endMinute: m(15) }] },
        { weekday: 5, windows: [{ startMinute: m(7), endMinute: m(15) }] },
      ],
      exceptions: [
        {
          managerId: asManagerId('mock-mgr-elena'),
          date: saturday,
          windows: [{ startMinute: m(9), endMinute: m(13) }],
        },
      ],
    },
  ]
}
